module.exports = __webpack_public_path__ + "img/licenciado.dddd07e9.jpg";